export default __webpack_public_path__ + "static/media/icon-eye-opened.02258102.svg";